// src/App.js
import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

const LoginPage      = lazy(() => import("./pages/LoginPage"));
const Dashboard      = lazy(() => import("./pages/Dashboard"));
const QRcode         = lazy(() => import("./pages/QRcode"));
const Sanction       = lazy(() => import("./pages/SanctionPage"));
const JustificatifsPage = lazy(() => import("./pages/JustificatifsPage"));
const Liste          = lazy(() => import("./pages/ListePointage"));
const RessetPage     = lazy(() => import("./pages/RessetPage"));
const DiscussionPage = lazy(() => import("./pages/DiscussionPage"));
const SSOCallback    = lazy(() => import("./pages/SSOCallback"));
// ✅ Page profil dédiée (remplace le modal)
const ProfilePage    = lazy(() => import("./pages/ProfilePage"));

// eslint-disable-next-line import/first
import NotificationCenter  from "./components/NotificationCenter";
// eslint-disable-next-line import/first
import ProtectedRoute      from "./component/ProtectionRoute";
// eslint-disable-next-line import/first
import { ToastProvider }   from "./component/ToastProvider";
// eslint-disable-next-line import/first
import { RouteErrorBoundary } from "./component/RouteErrorBoundary";
// eslint-disable-next-line import/first
import ErrorBoundary       from "./component/ErrorBoundary";
// eslint-disable-next-line import/first
import { AuthInitializer } from "./components/AuthInitializer.jsx";
// eslint-disable-next-line import/first
import { useAuth }         from "./contexts/AuthContext.jsx";

const PublicRoute = ({ children }) => {
  const { isAuthenticated, user } = useAuth();
  if (isAuthenticated) {
    const role = user?.role;
    if (role === "admin") return <Navigate to="/admin/dashboard" replace />;
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};

function App() {
  return (
    <ErrorBoundary name="App">
      <ToastProvider />
      <NotificationCenter />
      <Router>
        <AuthInitializer>
          <Suspense fallback={<div className="h-screen flex items-center justify-center">Chargement...</div>}>
            <Routes>

              {/* ══════════ ROUTES PUBLIQUES ══════════ */}
              <Route path="/" element={<PublicRoute><RouteErrorBoundary><LoginPage /></RouteErrorBoundary></PublicRoute>} />
              <Route path="/sso/callback" element={<RouteErrorBoundary><SSOCallback /></RouteErrorBoundary>} />
              <Route path="/reset-password" element={<PublicRoute><RouteErrorBoundary><RessetPage /></RouteErrorBoundary></PublicRoute>} />

              {/* ══════════ ROUTES PROTÉGÉES ══════════ */}
              <Route path="/dashboard"    element={<ProtectedRoute><RouteErrorBoundary><Dashboard /></RouteErrorBoundary></ProtectedRoute>} />
              <Route path="/qrcode"       element={<ProtectedRoute><RouteErrorBoundary><QRcode /></RouteErrorBoundary></ProtectedRoute>} />
              <Route path="/sanction"     element={<ProtectedRoute><RouteErrorBoundary><Sanction /></RouteErrorBoundary></ProtectedRoute>} />
              <Route path="/justificatifs" element={<ProtectedRoute><RouteErrorBoundary><JustificatifsPage /></RouteErrorBoundary></ProtectedRoute>} />
              <Route path="/liste"        element={<ProtectedRoute><RouteErrorBoundary><Liste /></RouteErrorBoundary></ProtectedRoute>} />
              <Route path="/discussion"   element={<ProtectedRoute><RouteErrorBoundary><DiscussionPage /></RouteErrorBoundary></ProtectedRoute>} />

              {/* ✅ Page profil coach — accessible depuis le dropdown Header */}
              <Route path="/profile"      element={<ProtectedRoute><RouteErrorBoundary><ProfilePage /></RouteErrorBoundary></ProtectedRoute>} />

              {/* ══════════ FALLBACK ══════════ */}
              <Route path="*" element={<Navigate to="/" replace />} />

            </Routes>
          </Suspense>
        </AuthInitializer>
      </Router>
    </ErrorBoundary>
  );
}

export default App;